import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn, faTelegramPlane, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Loader from '../../components/loader';
import SuccessAnim from '../../components/successanim';

import {
  fetchReferrals,
} from '../../actions';

class SuccessOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refPath: process.env.REACT_APP_HOSTNAME + '/register?ref=',
      dummyLoad: true,
      succId: 1,
      succText: 'Placing Order...',
      doneStage: 0,
    };
    this.dummyLoader = this.dummyLoader.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchReferrals());
    this.dummyLoader();
  }

  dummyLoader() {
    const nextStages = [
      {index: 1, doneStage: 0, succId: 1, succText: 'Placing Order...'},
      {index: 2, doneStage: 1, succId: 1, succText: 'Done!'},
      {index: 3, doneStage: 1, succId: 2, succText: 'Initiating Transfer...'},
      {index: 4, doneStage: 2, succId: 2, succText: 'Done!'},
      {index: 5, doneStage: 2, succId: 3, succText: 'Updating Portfolio...'},
      {index: 6, doneStage: 3, succId: 3, succText: 'Done!'},
    ];

    nextStages.forEach((elem, i) => {
      setTimeout(() => {
        if ((elem && elem.index) && (nextStages && nextStages.length && (nextStages.length === elem.index))) {
          this.setState({ doneStage: elem.doneStage, succId: elem.succId, succText: elem.succText, dummyLoad: false });
        } else {
          this.setState({ doneStage: elem.doneStage, succId: elem.succId, succText: elem.succText });
        }
      }, i * 1000);
    });
  }

  render() {
    const { newOrder, exchA, exchB, result, referrals } = this.props;
    const { refPath, dummyLoad, succId, succText, doneStage } = this.state;

    if (dummyLoad) {
      return (
        <div className="cell small-12 medium-8 large-6 vt-d-s">
          <div style={{textAlign: 'left', fontWeight: '600'}}>
            Vaultoro Direct
          </div>
          <div >
            <SuccessAnim id={succId} key={succId} />
          </div>
          <h3>{succText}</h3>
          <div className="timeline">
            <div className={doneStage >= 1 && 't-done'}>
              <span>1</span>
            </div>
            <div className={doneStage >= 2 && 't-done'}>
              <span>2</span>
            </div>
            <div className={doneStage >= 3 && 't-done'}>
              <span>3</span>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="cell small-12 medium-8 large-6 vt-d-s">
        <div style={{textAlign: 'left', fontWeight: '600'}}>
          Invite your friends
        </div>
        <div>
          <SuccessAnim key={succId} />
        </div>
        <h3>
          Congratulations your trade was successful!
        </h3>
        <ul>
          <li>
            You will see your current balance updated on your
            <a href="/portfolio"> portfolio page</a>
            .
          </li>
          <li>
            You can also see this purchase in the
            <a href="/history"> history page </a>
            marked as OTC.
          </li>
        </ul>
        <div className="button-area">
          <button type="button" className="vlt-button vt-ds-btn-ol" onClick={() => newOrder()}>
            <span>
              Do another trade!
            </span>
          </button>
          <a href="/referral" type="button" className="vlt-button vt-ds-btn">
            <span>
              Earn Bitcoin, Gold and More!
            </span>
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  result: state.order.orders.result,
  referrals: state.referral.referral,
});

export default connect(mapStateToProps)(SuccessOrder);
